import { coreLog } from '../../utilities/logger.js';
import isVolumeCompatible, {} from './supportsVolumeCompatibilityApi.js';
const log = coreLog.getLogger('RenderingEngine', 'addVolumesToViewports');
async function addVolumesToViewports(renderingEngine, volumeInputs, viewportIds, immediateRender = false, suppressEvents = false) {
    const compatibleViewports = [];
    for (const viewportId of viewportIds) {
        const viewport = renderingEngine.getViewport(viewportId);
        if (!viewport) {
            throw new Error(`Viewport with Id ${viewportId} does not exist`);
        }
        if (!isVolumeCompatible(viewport)) {
            log.warn(`Viewport with Id ${viewportId} does not implement addVolumes. Cannot add volume to this viewport.`);
            return;
        }
        compatibleViewports.push(viewport);
    }
    await Promise.all(compatibleViewports.map((viewport) => viewport.addVolumes(volumeInputs, immediateRender, suppressEvents)));
    return;
}
export default addVolumesToViewports;
